import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { BlockWidths } from '../../components/pageLayouts/BlockTypes.utils';
import { createBlockStyle } from '../blockMutualStyle';

interface ExperienceEmbedDataProps {
  divId: string;
  scriptUrl: string;
  dataId?: string;
  defaultBlocksWidths: BlockWidths;
}

type ExperienceEmbedProps = ExperienceEmbedDataProps & MandatoryAdditionalStyle;

const getStyle = (defaultBlocksWidths: BlockWidths) => StyleSheet.create({
  style: { ...createBlockStyle(defaultBlocksWidths) },
}).style;

export const ExperienceEmbed: React.FunctionComponent<ExperienceEmbedProps> = props => {
  const { divId, scriptUrl, dataId, additionalStyle, defaultBlocksWidths } = props;
  const containerRef = React.useRef<HTMLDivElement>(null);
  const injectedRef = React.useRef(false);
  const style = getStyle(defaultBlocksWidths);

  // Needs useEffect instead of Kasda.Script because we need to ensure the div is available before appending the script.
  React.useEffect(() => {
    const host = containerRef.current;
    if (!host || !divId || !scriptUrl || injectedRef.current) return undefined;
    injectedRef.current = true;
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    host.appendChild(script);
    return () => {
      injectedRef.current = false;
      script.remove();
    };
  }, [divId, scriptUrl]);

  if (!divId || !scriptUrl) return null;

  return (
    <ErrorBoundary>
      <div ref={containerRef} data-mm-id={dataId} className={css(additionalStyle.style, style)}>
        <div id={divId} />
      </div>
    </ErrorBoundary>
  );
};
